export default __webpack_public_path__ + "static/media/platforms_phone_and_tablet.9f0e0ddf.svg";